import { render, staticRenderFns } from "./ChargesRule.vue?vue&type=template&id=4b2c9778&scoped=true&"
import script from "./ChargesRule.vue?vue&type=script&lang=js&"
export * from "./ChargesRule.vue?vue&type=script&lang=js&"
import style0 from "./ChargesRule.vue?vue&type=style&index=0&id=4b2c9778&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2c9778",
  null
  
)

export default component.exports